import React, { useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Container from './Container';

import { localeData } from '@utils/locales';
import { getCustomData } from '@utils/Analysis';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: rem(20),
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  select: {
    fontSize: rem(18),
    border: 'none',
    backgroundColor: '#FFF',
    lineHeight: 20,
    outline: 'none',
  },
}), {
  name: 'Header'
})

const Header = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { data, setLocale } = props;
  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(i18n.language);
  const custom = getCustomData(data);
  const logoImage = R.pathOr('', ['logoimage', 'filelocation'])(custom);

  const handleChangeLan = (e) => {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    setLanguage(lng);
    setLocale(lng);
  }

  return (
    <Container className={classNames(classes.root)}>
      <Container 
        flex 
        justify='space-between' 
        alignItems='center' 
        style={{ width: '100%' }}
      >
        <img src={logoImage} width={130} alt="logo" />

        <select
          name='language_select'
          className={classes.select}
          value={language}
          onChange={e => handleChangeLan(e)}
        >
          {
            localeData && localeData.map(item => (
              <option 
                key={item.value}
                value={item.value}
              >
                {item.label}
              </option>
            ))
          }
        </select>
      </Container>

    </Container>
  )
};

Header.propTypes = {
  data: PropTypes.object.isRequired,
  setLocale: PropTypes.func.isRequired,
}

export default Header;
